// @ts-check
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import Icon from 'components/base/Icon';
import { LBButton } from '@linearb/buzz';

const DeleteDashboardModal = ({ deleteDashboard, close, name }) => {
  return (
    <Flex direction='column' padding='medium' justify='space-between'>
      <Flex pb='medium' items='end'>
        <Icon name='Trash' size='medium' color='nepal' />
        <Text size='large' weight='400' color='black' pl='0.5rem'>
          Delete this dashboard?
        </Text>
      </Flex>
      <Text size='medium' lineHeight='1.5'>
        Do you want to permanently delete the "{name}" dashboard? Deleting this
        dashboard means you will not see it here anymore
      </Text>
      <Flex pt='normal' justify='flex-end' gap='1rem'>
        <LBButton
          data-testid='cancel-delete-dashboard-testid'
          variant='outline'
          onClick={() => close()}
        >
          Cancel
        </LBButton>
        <LBButton
          data-testid='delete-dashboard-testid'
          onClick={deleteDashboard}
          data-cy='confirm-deletion'
        >
          Delete dashboard
        </LBButton>
      </Flex>
    </Flex>
  );
};

export default DeleteDashboardModal;
